import { Text } from '@radix-ui/themes'
import { useNavigate } from '@tanstack/react-router'
import { IconArrowLeft } from '@tabler/icons-react'
import clsx from 'clsx'
import { hoverPressable } from '@/utils/style'
import Hstack from '@/components/ui/hstack'

type HeaderEditProps = {
  route?: string
  params?: Record<string, string>
  children?: React.ReactNode
  className?: string
}
export default function HeaderEdit({
  children,
  className,
  route,
  params,
}: HeaderEditProps) {
  const navigate = useNavigate()
  return (
    <Hstack
      height={'72px'}
      gap={'32px'}
      align={'center'}
      justify={'between'}
      className={clsx(className, 'ml-[2px] px-[40px]')}
    >
      <Hstack
        py={'10px'}
        className={hoverPressable}
        style={{
          cursor: 'pointer',
        }}
        onClick={() => {
          if (!route) {
            navigate({ to: '..' })
            return
          }
          navigate({
            to: route,
            params: params || {},
          })
        }}
      >
        <IconArrowLeft width={'25px'} height={'25px'} color='#F6F7F9' />
        <Text className='text-[16px] font-medium text-[#F6F7F9]'>Back</Text>
      </Hstack>
      {children}
    </Hstack>
  )
}
